import React from 'react';
import { FiChevronUp } from "react-icons/fi";
import { FiChevronDown } from "react-icons/fi";

const ScrollModalButtons = () => {
  const handleScroll = (direction) => {
    const modalElement = document.querySelector('[data-testid="modal-overlay"]') ;
    if (direction === 'top' && modalElement) {
      modalElement.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
    if (direction === 'bottom') {
      modalElement.scrollTo({
        top: modalElement.scrollHeight,
        behavior: "smooth"
      })
    }
  };

  return (
    <div className="fixed bottom-4 right-5 flex flex-col z-[100]">
      <button onClick={() => handleScroll('top')} className="focus:outline-none focus:ring-0 mb-4 hover:bg-none bg-[#475467] flex items-center justify-center w-[44px] h-[44px] rounded-[4px]">
        <FiChevronUp className="text-white font-medium" size={30} />
      </button>
      <button onClick={() => handleScroll('bottom')} className="focus:outline-none focus:ring-0 hover:bg-none bg-[#475467] flex items-center justify-center w-[44px] h-[44px] rounded-[4px]">
        <FiChevronDown className="text-white font-medium" size={30} />
      </button>
    </div>
  );
};

export default ScrollModalButtons;
